package com.macrofocus.eflux.ui

import js.objects.unsafeJso
import mui.material.Fab
import mui.material.Icon
import mui.material.styles.Theme
import mui.material.styles.useTheme
import react.FC
import react.Props
import web.cssom.Position
import web.cssom.px

val CloseAllTooltipsButton = FC<CloseAllTooltipsButtonProps> { props ->
    Fab {
        val color = useTheme<Theme>().asDynamic().palette.text.primary
        val backgroundColor = useTheme<Theme>().asDynamic().palette.background.default
        sx = unsafeJso {
            position = Position.absolute
            bottom = 10.px
            right = 10.px
            this.color = color
            this.backgroundColor = backgroundColor
        }

//            classes(classes.root)
//            size = ButtonSize.small
            title = "Close all tooltips"
            ariaLabel = "Close all tooltips"
//            color = ButtonColor.inherit
            onClick = {
                props.onClose()
            }

        Icon {
//            attrs.classes(classes.icon)
            +"close_icon"
        }
    }
}

external interface CloseAllTooltipsButtonProps : Props {
    var onClose: () -> Unit
}
